import * as core from '../../../../../../../core'
import * as changeImpacts from '../change-impacts'

export const RESOURCE = {
  payload: {
    alias: 'change.impacts',
    appAlias: changeImpacts.RESOURCE.payload.alias,
    description: 'Filterable list of change impacts',
    display: {
      isMain: false,
      position: 0,
    },
    name: 'Change Impacts',
    page: { alias: 'change.impacts' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
